import { CircleChevronDown } from 'lucide-react';

import userStatusColor from '../../../../../utils/userStatusColor';
import { statusName } from '../helper';
import { StatusSelectorProps } from '../types';
import Options from './Options';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../../../../lib/tooltip';
import { Skeleton } from '../../../../../lib/skeleton';
import { Button } from '../../../../../lib/button';

const StatusSelector: React.FC<StatusSelectorProps> = ({
    working,
    currentStatus,
    loadingStatus,
    isLoading,
    setLoadingStatus,
    endActivityStatus,
    startActivityStatus,
    showOptions,
    setShowOptions
}) => {
    const optionsProps = {
        currentStatus,
        loadingStatus,
        isLoading,
        setLoadingStatus,
        endActivityStatus,
        startActivityStatus,
        showOptions
    };
    const label = currentStatus === statusName.intake ? 'Intake' : currentStatus.replace('_', ' ');
    const clickHandler = working && currentStatus !== '' ? () => setShowOptions(!showOptions) : undefined;

    return (
        <div onClick={clickHandler}>
            {currentStatus !== '' && (
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <div className="flex w-full justify-between items-center p-4 border-t border-gray-200 hover:cursor-pointer">
                                {!isLoading && !loadingStatus ? (
                                    <>
                                        <span className="capitalize" style={{ color: userStatusColor(currentStatus) }}>
                                            {label}
                                        </span>
                                        <Button
                                            id="showOptions"
                                            variant="blue"
                                            className="p-0 h-6 w-6 rounded-full"
                                            style={{ backgroundColor: userStatusColor(currentStatus) }}
                                        >
                                            <CircleChevronDown className="h-6 w-6" />
                                        </Button>
                                    </>
                                ) : (
                                    <div className="flex gap-2 items-center">
                                        <Skeleton className="w-28 h-4" />
                                        <Skeleton className="w-6 h-6 rounded-full" />
                                    </div>
                                )}
                            </div>
                        </TooltipTrigger>
                        {currentStatus === statusName.intake && (
                            <TooltipContent>
                                <p>Please, finish the Intake to change the status.</p>
                            </TooltipContent>
                        )}
                    </Tooltip>
                </TooltipProvider>
            )}
            <Options {...optionsProps} />
        </div>
    );
};
export default StatusSelector;
